export const URL_CHANGE_EVENT = "url:change";
export const URL_SCROLLED_EVENT = "url:scrolled";
export const PAGE_LOAD_EVENT = "page:loaded";
export const READ_ARTICLE_EVENT = "read-article:click";
export const POST_SHARED_EVENT = "post:shared";
